import React from 'react';
import { Col, Container, Modal, ModalBody, Row, Label, Input, Form, FormGroup } from 'reactstrap';
import modalclose from '../../../images/close.png';
import FYearService from '../../../services/FYearService';
import { CommonButton } from '../../CommonComponents';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import './index.css';

const CommitmentModal = ({ isModalLoading, isOpen, toggle, editCommitmentId, productId, product, commitment, secondYearcommitment, thirdYearcommitment, productUnit, handleProduct, handleSubmitCommmitment }) => {
    let fYYear = FYearService.getFYear();
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="commitmentModal" id='commitmentModal'>
            {isModalLoading && <CustomSpinner />}
            <ModalBody className='p-0'>
                <div className='bodyArea'>
                    <Container fluid>
                        <Row>
                            <Col xs={12}>
                                <div className="closeButton d-flex justify-content-end mb-2 mt-3">
                                    <img src={modalclose} alt="close" onClick={toggle} className="cursorPointer" />
                                </div>
                                <div className='modalHeading'>
                                    <div className='title text-capitalize'>Add Business Commitment for Next 3 Financial Year</div>
                                </div>
                            </Col>
                        </Row>
                        <Form onSubmit={handleSubmitCommmitment} id='form-reset'>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className='common-input-label'>Product Name <span className='required'>*</span></Label>
                                        <div className='select-wrapper'>
                                            <Input
                                                type='select'
                                                id='select'
                                                required
                                                name='select'
                                                value={
                                                    productId === null || productId === 'undefined'
                                                        ? ''
                                                        : productId
                                                }
                                                onChange={(e) => {
                                                    handleProduct(e, 1);
                                                }}
                                                disabled={editCommitmentId}
                                                style={{ cursor: `${editCommitmentId ? 'auto' : 'pointer'}` }}
                                            >
                                                <option disabled value={''}>
                                                    Select
                                                </option>
                                                {product.length > 0 &&
                                                    product.map((prod, index) => {
                                                        return (
                                                            <option key={index} value={prod.id}>
                                                                {prod.name}
                                                            </option>
                                                        );
                                                    })}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='common-input-label'>{`Commitment for ${fYYear.next3FinancialYear[0]} Year`} <span className='required'>*</span></Label>
                                        <br />
                                        <div className='d-flex'>
                                            <Input
                                                type='text'
                                                autoComplete='off'
                                                name='detail'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                value={
                                                    commitment === null || commitment === 'undefined'
                                                        ? ''
                                                        : commitment
                                                }
                                                required
                                                onChange={(e) => {
                                                    handleProduct(e, 2);
                                                }}
                                                id='detail'
                                                placeholder='Type here'
                                            />
                                            &nbsp;<span className='pt-3'>{productUnit}</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='common-input-label'>{`Commitment for ${fYYear.next3FinancialYear[1]} Year`} <span className='required'>*</span></Label>
                                        <br />
                                        <div className='d-flex'>
                                            <Input
                                                type='text'
                                                autoComplete='off'
                                                name='detail'
                                                value={
                                                    secondYearcommitment === null ||
                                                        secondYearcommitment === 'undefined'
                                                        ? ''
                                                        : secondYearcommitment
                                                }
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                required
                                                onChange={(e) => {
                                                    handleProduct(e, 3);
                                                }}
                                                id='detail'
                                                placeholder='Type here'
                                            />
                                            &nbsp;<span className='pt-3'>{productUnit}</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='common-input-label'>{`Commitment for ${fYYear.next3FinancialYear[2]} Year`} <span className='required'>*</span></Label>
                                        <br />
                                        <div className='d-flex'>
                                            <Input
                                                type='text'
                                                autoComplete='off'
                                                name='detail'
                                                value={
                                                    thirdYearcommitment === null ||
                                                        thirdYearcommitment === 'undefined'
                                                        ? ''
                                                        : thirdYearcommitment
                                                }
                                                required
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    handleProduct(e, 4);
                                                }}
                                                id='detail'
                                                placeholder='Type here'
                                            />
                                            &nbsp;<span className='pt-3'>{productUnit}</span>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='modalBtn d-flex align-items-center justify-content-center'>
                                        <CommonButton name={editCommitmentId ? 'Update' : 'Add'} btnClass={'btnPrimary'} type="submit" />
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default CommitmentModal
